/**
 * logger
 * @author  Jerry <jerry.hz.china@gmail.com>
 * @since   2025-03-27 11:34:14
 */

/** 判断是否开发环境 */
const isDev = () => '127.0.0.1' === window.location.hostname;

export const useLogger = (prefix, option) => {
  const { color, throttleTime = 200 } = option ?? { color: '#f9d' };

  const Log = (...rest) =>
    isDev() ? console.log('%c%s', `color:${color};`, `[${prefix}]`, ...rest) : () => {};

  const Group = str =>
    isDev() ? console.group('%c%s', `color:${color};`, `[${prefix}] ${str}`) : () => {};

  const GroupEnd = isDev() ? console.groupEnd : () => {};

  Log('Logger初始化完成');

  return { Log, Group, GroupEnd };
};
